// extracted by mini-css-extract-plugin
export default {"buttonContainer":"_-8VDL","alignToEdge":"_8qoLP","buttonIcon":"SyLtW","buttonCaption":"EbcI8","buttonSpacer":"_713mT"};